import {
  CustomGetCrewsQuery,
  CustomGetCrewsQueryVariables,
  useCustomGetCrewsQuery,
} from "generated/graphql";
import { useCallback, useMemo } from "react";

export default function useGetCrews({
  page = 1,
  first = 10,
  search,
  sort,
}: CustomGetCrewsQueryVariables) {
  const {
    data: graphqlData,
    loading,
    error,
    fetchMore: more,
  } = useCustomGetCrewsQuery({
    variables: {
      page,
      first,
      search,
      sort,
    },
  });

  const fetchMore = useCallback(
    async ({ page }: { page: number }) => {
      return more({
        variables: {
          page,
        },
      });
    },
    [more]
  );

  const getData = useCallback(({ data }: { data?: CustomGetCrewsQuery }) => {
    return data?.getCrews?.data || null;
  }, []);

  const getPaginatorInfo = useCallback(({ data }: { data?: CustomGetCrewsQuery }) => {
    return data?.getCrews?.paginatorInfo || null;
  }, []);

  const data = useMemo(() => {
    return getData({ data: graphqlData });
  }, [graphqlData, getData]);

  const paginatorInfo = useMemo(() => {
    return getPaginatorInfo({ data: graphqlData });
  }, [graphqlData, getPaginatorInfo]);

  return { data, loading, error, paginatorInfo, fetchMore, getData, getPaginatorInfo } as const;
}
